import { render, staticRenderFns } from "./HealthAnalysis.vue?vue&type=template&id=cd4acf34&scoped=true&"
import script from "./HealthAnalysis.vue?vue&type=script&lang=js&"
export * from "./HealthAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./HealthAnalysis.vue?vue&type=style&index=0&id=cd4acf34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4acf34",
  null
  
)

export default component.exports